import { createStyles } from '@svg/antd/es/theme/utils';

/**
 * @description 搜索下拉面板样式
 */
export default createStyles(({ token, css }) => ({
  popover: css`
    & {
      &.mini-popover {
        .ant-popover-content {
          .ant-popover-inner {
            padding: 12px 0 !important;
          }
        }
        /* 最近搜索 */
        .search-history-section {
          padding: 0 12px 12px;
          .hot-tag {
            padding: 2px 8px;
          }
        }
        .search-scope-title {
          margin-bottom: 12px;
        }
        /* 区块标题 */
        .section-title {
          margin-bottom: 8px;
        }
        /* 热搜区块 */
        .hot-search-section {
          padding: 12px 12px 0px;
          .hot-tag {
            padding: 2px 8px;
          }
        }
        .topic-entry-section {
          padding: 8px 12px 0;
        }
        .topic-entry-card {
          min-width: 150px;
        }
         /* 搜索范围区块 */
        .search-scope-section {
          padding: 0 0 8px 0px;
        }
        .list-item {
          padding: 8px 12px;
        }
        /* 分割线样式 */
        .section-divider {
          .ant-divider {
            width: calc(100% - 24px);
          }
        }
        /* 分类推荐项 */
        .category-recommend-item {
          padding: 8px 12px;
        }
        .secondary {
          padding: 6px 12px;
        }
         /* 类目推荐区块 */
        .category-recommend-section {
          padding: 8px 0px;
        }
        .guess-search-section {
          padding: 8px 0px 0 0;
        }
      }
      & {
        .ant-popover-content {
          .ant-popover-inner {
            border-radius: 8px;
            background: ${token.colorBgContainer};
            box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.16);
            padding: 16px 0;
          }
        }
        /* 为 Popover body 添加宽度过渡动画（仅在显示时） */
        .ant-popover-inner-content {
          /* 动画由内联样式控制，这里不设置默认动画 */
        }
        .ant-space {
          width: 100%;
          .ant-space-item {
            max-width: 100%;
          }
        }
        
        /* 下拉面板基础样式 */
        .dropdown-container {
          background: ${token.colorBgContainer};
          width: 100%;
          /* max-height: 480px; */
          overflow-y: auto;
          font-family: ${token.fontFamily};
        }

        /* 搜索历史区块 */
        .search-history-section {
          padding: 20px 24px;
          .icon-delete1 {
            color: #959598;
            margin-left: auto;
            cursor: pointer;
          }
          
        }
        .hot-tag {
          padding: 8px 16px;
          border-radius: 8px;
          background: ${token.colorFillTertiary};
          color: ${token.colorTextSecondary};
          font-size: 14px;
          cursor: pointer;
          max-width: 400px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        /* 热搜区块 */
        .hot-search-section {
          padding: 12px 24px 16px;
          /* 热搜标签样式 */
          .ant-space-item {
            /* 热搜排名样式 - 第一名 */
            &:nth-child(1) {
              .hot-tag {
                color: #F5222D;
                background: linear-gradient(90deg, rgba(245, 34, 45, 0.05) 0%, rgba(245, 34, 45, 0.15) 100%);
              }
            }
            
            /* 热搜排名样式 - 第二名 */
            &:nth-child(2) {
              .hot-tag {
                color: #FF6441;
                background: linear-gradient(270deg, rgba(255, 100, 65, 0.05) 0%, rgba(255, 100, 65, 0.15) 100%);
              }
            }
            
            /* 热搜排名样式 - 第三名 */
            &:nth-child(3) {
              .hot-tag {
                color: #FA8C16;
                background: linear-gradient(90deg, rgba(250, 140, 22, 0.05) 0%, rgba(250, 140, 22, 0.15) 100%);
              }
            }
            
            /* 热搜排名样式 - 第四名及以后 */
            &:nth-child(n+4) {
              .hot-tag {
                color: #5B5E60;
                background: #F2F3F5;
              }
            }
          }
        }

        /* 素材专题入口 */
        .topic-entry-section {
          padding: 4px 24px 0;
        }
        .topic-entry-list {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
        }
        .topic-entry-card {
          display: flex;
          align-items: center;
          gap: 8px;
          width: 166px;
          height: 60px;
          padding: 6px;
          border-radius: 4px;
          background: linear-gradient(90deg, #fff9e8 0%, #ffebc5 100%);
          cursor: pointer;
          outline: none;
          box-sizing: border-box;
          transition: box-shadow 0.2s;

          &:hover,
          &:focus-visible {
            box-shadow: 0 4px 12px rgba(250, 140, 22, 0.22);
          }
        }
        .topic-entry-cover {
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 0 0 auto;
          width: 56px;
          height: 48px;
          border: 1px solid rgba(255, 255, 255, 0.9);
          border-radius: 4px;
          background: linear-gradient(180deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0.6) 100%);
          overflow: hidden;
        }
        .topic-entry-image {
          width: 40.205px;
          height: 40.205px;
          object-fit: contain;
        }
        .topic-entry-icon-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.72);
          color: #ad6800;
        }
        .topic-entry-icon {
          font-size: 22px;
          line-height: 1;
        }
        .topic-entry-content {
          display: flex;
          flex-direction: column;
          gap: 2px;
          white-space: nowrap;
          overflow: hidden;
        }
        .topic-entry-title {
          color: #282a2d;
          font-weight: 600;
          font-size: 14px;
          line-height: 22px;
          max-width: 90px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .topic-entry-subtitle {
          color: rgba(0, 0, 0, 0.4);
          font-size: 12px;
          line-height: 12px;
          max-width: 90px;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        /* 搜索范围区块 */
        .search-scope-section {
          padding: 12px 0px;
        }

        /* 搜索范围标题 */
        .search-scope-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          color: ${token.colorTextSecondary};
          font-size: ${token.fontSizeSM}px;
        }
        .secondary {
          padding: 6px 24px;
          color: #959598;
          font-size: 12px;
        }

        /* 类目推荐区块 */
        .category-recommend-section {
          padding: 12px 0px;
        }

        /* 猜你想搜区块 */
        .guess-search-section {
          padding: 12px 0px;
        }

        /* 区块标题 */
        .section-title {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          color: #282828;
          font-weight: 600;
          font-size: 14px;
          cursor: default;
        }
        

        /* 列表项悬停效果 */
        .list-item {
          cursor: pointer;
          padding: 8px 24px;
          color: #282828;
          font-size: 13px;
          transition: background 0.2s;
          
          &:hover {
            background: ${token.colorFillAlter};
          }
        }
        /* 分类推荐项 */
        .category-recommend-item {
          cursor: pointer;
          padding: 8px 24px;
          color: #282828;
          font-size: 13px;
          transition: background 0.2s;
          span {
            &:last-child {
              font-weight: 600;
            }
          }
          &:hover {
            background: ${token.colorFillAlter};
          }
        }
        /* 搜索关键词高亮 */
        .search-text {
          padding: 0 2px;
          color: #147ffa;
          font-size: 13px;
        }


        /* 分割线样式 */
        .section-divider {
          display: flex;
          justify-content: center;
          .ant-divider {
            width: calc(100% - 48px);
            margin: 0px;
            min-width: auto;
          }
        }
        
        /* 隐藏 Popover 的样式 */
        &.hidden-popover {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          pointer-events: none !important;
        }
      }
    }
  `,
}));
